import React from 'react'
import PropTypes from 'prop-types'
import StepperActionBar from '../StepperActionBar'
import { SectionWrapper, ErrorMessage, ActionBarWrapper } from '../common'

const ServiceSelector = ({ children, currentStepIndex, error, submitFailed, onPrevPage, handleSubmit }) =>
  <form onSubmit={ handleSubmit }>
    <SectionWrapper>
      { children }
      <ActionBarWrapper>
        <StepperActionBar
          hasPrevPage
          hasNextPage
          isPrevPageVisible
          currentStepIndex={ currentStepIndex }
          prevPageClick={ onPrevPage } />

        <ErrorMessage
          role="alert"
          aria-live="assertive"
          aria-label={ error }>
          { (submitFailed && error) || '' }
        </ErrorMessage>
      </ActionBarWrapper>
    </SectionWrapper>
  </form>

export default ServiceSelector

ServiceSelector.propTypes = {
  children: PropTypes.node,
  currentStepIndex: PropTypes.number,
  error: PropTypes.string,
  handleSubmit: PropTypes.func,
  onPrevPage: PropTypes.func,
  submitFailed: PropTypes.bool
}
